"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlEncode = exports.getPropertyDisplayName = exports.disqualifyLiveFlowClause = exports.testPropertyClause = exports.getClauseReduxId = exports.stripDomainClauses = exports.getMasterClause = undefined;

var _constants = require("./constants");

var getMasterClause = exports.getMasterClause = function getMasterClause(clauses) {
  return clauses.find(function (it) {
    return !clauses.find(function (c) {
      return c.id === it.parentId;
    });
  });
};

var stripDomainClauses = exports.stripDomainClauses = function stripDomainClauses(clauses) {
  return clauses.filter(function (clause) {
    return clause.conditionName === _constants.conditionNames.DOMAINS;
  });
};

/**
 * Generates a sequential id in the form `${parentId}-${siblingCount + 1}` based on
 * conditions in state for a particular step.
 *
 * Given the following `clauses`...
 *
 * - [ { id: "1" }, { id: "1-1", parentId: "1" } ]
 *
 * Returns the following for `parentId`...
 *
 * - null  => "2"
 * - "1"   => "1-2"
 * - "1-1" => "1-1-1"
 *
 * @param clauses
 * @param parentId
 * @returns {string}
 */

var getClauseReduxId = exports.getClauseReduxId = function getClauseReduxId(clauses, parentId) {
  var siblingClauses = clauses.filter(function (it) {
    return it.parentId === parentId;
  });

  var maxSiblingId = siblingClauses.reduce(function (prev, it) {
    // This line of code makes sure that we are comparing the properly nested index value.
    // For example, if a step has an id of 1-2-4-1 with a parent id of 1-2 (which can happen when a nested group is ungrouped)
    // we use the 3rd number in the sequence (in this case 4) as the comparator as opposed to the last index value.
    var siblingId = parseInt(("" + (it.id || "")).slice(parentId.length + 1).split("-")[0]);

    return siblingId > prev ? siblingId : prev;
  }, 0);

  return "" + (parentId ? parentId + "-" : "") + (maxSiblingId + 1);
};

var testPropertyClause = exports.testPropertyClause = function testPropertyClause(ghostFlowId) {
  return {
    conditionName: _constants.conditionNames.PROPERTIES,
    operator: _constants.propertyOperators.EQUALS,
    property: "_testContentId",
    value: ghostFlowId
  };
};

var disqualifyLiveFlowClause = exports.disqualifyLiveFlowClause = function disqualifyLiveFlowClause(ghostFlowId) {
  return {
    conditionName: _constants.conditionNames.PROPERTIES,
    operator: _constants.propertyOperators.NOT_EQUALS,
    property: "_testContentId",
    value: ghostFlowId
  };
};

/**
 * Converts an "encoded" property name (e.g. camel or snake case)
 * and returns a friendly-looking version of it.
 *
 * @param prop
 */
var getPropertyDisplayName = exports.getPropertyDisplayName = function getPropertyDisplayName(prop) {
  return prop
  // Remove custom prefixes.
  .replace(/^_appcuesForm_/g, "Form Response: ").replace(/^_appcuesSatisfaction_/g, "")
  // Replace - _ . + with spaces.
  .replace(/[\-_\.\+]/g, " ")
  // Replace "abcD" with "abc D", "abcDEF" with "abc DEF".
  .replace(/([a-z]+)([A-Z]+)/g, function (m, g1, g2) {
    return g1 + " " + g2;
  })
  // Replace "Abcd" with " Abcd", discarding a starting space if it's there.
  .replace(/(\s?)([A-Z])([a-z]+)/g, function (m, g1, g2, g3) {
    return " " + g2 + g3;
  })
  // Take common all-caps acronyms and capitalize them.
  .replace(/\b(id|url|os|ip|eid|fb|crm|uuid|nps)\b/gi, function (m, g1) {
    return "" + g1.toUpperCase();
  })
  // Upper case the first character of each space separated word.
  .replace(/(\w)(\w*)/g, function (m, g1, g2) {
    return "" + g1.toUpperCase() + g2;
  }).trim();
};

/**
 * Encode HTML value to prevent XSS attacks
 *
 * @param str
 * @returns {string}
 */

var htmlEncode = exports.htmlEncode = function htmlEncode(str) {
  return String(str).replace(/[^\w. ]/gi, function (c) {
    return "&#" + c.charCodeAt(0) + ";";
  });
};